import { NotImplementedError } from "utilities/src/errors";
export function easeInEaseOutLayoutAnimation(_options) {
  throw new NotImplementedError("easeInEaseOutLayoutAnimation");
}
